import PropTypes from "prop-types";
import StatusChip from "@components/ui-components/status-chip";
import { formatDate } from "@helpers/date";
import { formatCurrency } from "@helpers/utils";
import { DEBIT_NOTE_STATUS_LABEL, DEBIT_NOTE_STATUS_TONE } from "@constants/panel/common";

// The dashboard returns only the latest few active notes; `total` is the full count
// so the card can say how many more sit behind the Debit notes tab.
const ActiveDebitNotesCard = ({ notes, total }) => (
    <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
        <div className="flex items-baseline justify-between">
            <h3 className="text-sm font-semibold text-gray-900">Latest active debit notes</h3>
            <span className="text-xs text-muted">{total ?? notes.length} active</span>
        </div>

        {notes.length === 0
            ? <p className="py-6 text-center text-sm text-muted">No active debit notes.</p>
            : (
                <div className="mt-2 divide-y divide-gray-100">
                    {notes.map((note) => (
                        <div key={note._id} className="flex items-center justify-between gap-3 py-3 text-sm">
                            <div className="min-w-0">
                                <p className="truncate font-mono text-xs font-medium text-gray-900">{note.debit_note_number}</p>
                                <p className="mt-0.5 text-xs text-muted">{note.payout_period || "—"} · Raised {formatDate(note.createdAt)}</p>
                            </div>
                            <div className="flex shrink-0 items-center gap-3">
                                <StatusChip tone={DEBIT_NOTE_STATUS_TONE[note.status] || "neutral"} label={DEBIT_NOTE_STATUS_LABEL[note.status] || note.status} />
                                <span className="w-28 text-right font-medium text-gray-900">{formatCurrency(note.amount, note.currency)}</span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
    </div>
);

ActiveDebitNotesCard.propTypes = {
    notes: PropTypes.arrayOf(PropTypes.object).isRequired,
    total: PropTypes.number
};

export default ActiveDebitNotesCard;
